import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mapToIterable',
    standalone: false,
})
export class MapToIterablePipe implements PipeTransform {
    transform(value: any, wrapKey?: string, wrapValue?: string): any {
        if (!value) return [];

        return Object.keys(value).map((key) => {
            if (wrapKey) {
                let ret: any = {};
                ret[wrapKey] = key;

                if (wrapValue) ret[wrapValue] = value[key];
                else ret['value'] = value[key];

                return ret;
            } else return value[key];
        });
    }
}
